/*
 * Herbst-Promo (shopweit): Aktionscode automatisch einlösen + Gratis-Geschenke auffüllen.
 * Konfiguration: snippets/herbst-promo.liquid (Theme-Einstellungen „Aktion: Code & Geschenke“).
 *
 * Die Rabatte selbst kommen aus Discount Plus. Dieses Skript sorgt nur dafür, dass
 *  - der Code im Warenkorb steckt (nicht, wenn schon ein anderer Code drin ist → Influencer-Zuordnung bleibt),
 *  - die freigeschalteten Geschenke im Warenkorb liegen, damit der Geschenk-Rabatt sie auf 0 € setzen kann.
 *
 * Geschenke werden aufgefüllt, nicht blind hinzugefügt: Discount Plus macht je Stufe den billigsten
 * berechtigten Artikel gratis, auch einen gekauften. Deshalb nur so viele Geschenke dazulegen, wie
 * freigeschaltet sind, abzüglich gekaufter berechtigter Artikel.
 *
 * Schwelle = Warenkorb nach Rabatt ohne automatisch hinzugefügte Geschenke. Das ist strenger als
 * „Cart subtotal“ in Discount Plus → ein hinzugefügtes Geschenk ist dort sicher freigeschaltet.
 *
 * Testmodus: ?promo_test=1 ignoriert den Zeitraum für diese Browser-Sitzung (Logs in der Konsole),
 * ?promo_test=0 beendet ihn.
 */
(() => {
  if (window.HerbstPromo) return;
  const cfgEl = document.getElementById('HerbstPromoConfig');
  if (!cfgEl) return;

  const cfg = JSON.parse(cfgEl.textContent);
  const PROP = '_herbst_geschenk';
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const gifts = (cfg.gifts || []).filter((g) => g.available && g.min > 0).sort((a, b) => a.min - b.min);

  // ---------- Sitzungsspeicher ----------
  const store = {
    get(k, d) {
      try {
        const v = JSON.parse(sessionStorage.getItem(`herbstPromo:${k}`));
        return v === null ? d : v;
      } catch (e) {
        return d;
      }
    },
    set(k, v) {
      try {
        sessionStorage.setItem(`herbstPromo:${k}`, JSON.stringify(v));
      } catch (e) {
        /* privater Modus o. Ä. */
      }
    },
  };

  const qp = new URLSearchParams(window.location.search).get('promo_test');
  if (qp === '1') store.set('test', true);
  if (qp === '0') store.set('test', false);
  const test = store.get('test', false);
  const log = (...a) => test && console.info('[herbst-promo]', ...a);

  // ---------- Zeitraum ----------
  const time = (s) => {
    const d = s ? new Date(s) : null;
    return d && !isNaN(d.getTime()) ? d.getTime() : null;
  };
  const start = time(cfg.start);
  const end = time(cfg.end);
  function active() {
    if (test) return true;
    if (!start) return false; // ohne gültigen Start nie aktiv
    const now = Date.now();
    return now >= start && (!end || now < end);
  }

  // ---------- Warenkorb-API ----------
  const nativeFetch = window.fetch.bind(window);
  async function req(url, body) {
    const res = await nativeFetch(
      url,
      body
        ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
        : { headers: { Accept: 'application/json' } }
    );
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.status) throw new Error(json.description || json.message || `HTTP ${res.status}`);
    return json;
  }
  const getCart = () => req(`${cfg.cartUrl}.js`);
  const isAuto = (l) => !!(l.properties && l.properties[PROP]);
  const prefixes = (cfg.combinePrefixes || []).map((p) => String(p).trim().toLowerCase()).filter(Boolean);
  const combinable = (code) => prefixes.some((p) => code.toLowerCase().startsWith(p));

  // ---------- Geschenke planen ----------
  function planGifts(cart, on) {
    const lines = cart.items;
    const auto = lines.filter(isAuto);
    // Bestellrabatte (z. B. eingelöste LoyaltyLion-Punkte) zählen nicht gegen die Schwelle
    const orderDisc = (cart.cart_level_discount_applications || []).reduce((a, d) => a + (d.total_allocated_amount || 0), 0);
    const base = cart.total_price + orderDisc - auto.reduce((a, l) => a + l.final_line_price, 0);
    const unlocked = on && !store.get('paused', false) ? gifts.filter((g) => base >= g.min) : [];
    const boughtQty = (v) => lines.filter((l) => !isAuto(l) && l.variant_id === v).reduce((a, l) => a + l.quantity, 0);
    const bought = unlocked.reduce((a, g) => a + boughtQty(g.variant), 0);
    const need = Math.max(0, unlocked.length - bought);

    // Selbst entfernte Geschenke nicht wieder hinzufügen (gilt für diese Sitzung)
    const added = store.get('added', []);
    const declined = store.get('declined', []);
    added.forEach((v) => {
      if (!auto.some((l) => l.variant_id === v) && !declined.includes(v)) declined.push(v);
    });
    store.set('declined', declined);
    store.set('added', added.filter((v) => auto.some((l) => l.variant_id === v)));

    const want = [];
    for (const g of unlocked) {
      if (want.length >= need) break;
      if (boughtQty(g.variant) > 0 || declined.includes(g.variant)) continue;
      want.push(g.variant);
    }

    const remove = [];
    const have = new Map();
    auto.forEach((l) => have.set(l.variant_id, [...(have.get(l.variant_id) || []), l]));
    have.forEach((ls, v) => {
      let left = want.includes(v) ? 1 : 0;
      ls.forEach((l) => {
        const q = Math.min(l.quantity, left);
        left -= q;
        if (q !== l.quantity) remove.push({ key: l.key, qty: q, variant: v });
      });
    });
    const add = want.filter((v) => !have.has(v));
    return { base, unlocked: unlocked.map((g) => g.title), bought, need, add, remove };
  }

  // ---------- Abgleich ----------
  let busy = false;
  let again = false;
  let timer = null;

  function schedule(reason) {
    clearTimeout(timer);
    timer = setTimeout(() => reconcile(reason), 450);
  }

  async function reconcile(reason) {
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    let changed = false;
    try {
      let cart = await getCart();
      const on = active();

      // Warenkorb leer (z. B. nach dem Kauf) → Sitzungsmerker zurücksetzen
      if (!cart.item_count) {
        store.set('added', []);
        store.set('declined', []);
      }

      // 1. Code zuerst einlösen: die Geschenk-Schwelle rechnet nach Rabatt
      // auch bei leerem Warenkorb, damit „Code aktiviert“ sofort sichtbar ist.
      // Andere Codes bleiben unangetastet; nur kombinierbare (z. B. LoyaltyLion „LL-…“) bekommen den Code dazu.
      const codes = (cart.discount_codes || []).map((d) => d.code);
      const hasOwn = codes.some((c) => c.toLowerCase() === String(cfg.code).toLowerCase());
      if (on && cfg.code && !hasOwn && codes.every(combinable)) {
        cart = await req(`${cfg.updateUrl}.js`, { discount: [...codes, cfg.code].join(',') });
        log('Code eingelöst', cart.discount_codes);
        changed = true;
      }

      // 2. Geschenke auffüllen / entfernen (mit Warenkorb nach Code)
      const plan = planGifts(cart, on);
      if (plan.remove.length) {
        const updates = {};
        plan.remove.forEach((r) => (updates[r.key] = r.qty));
        await req(`${cfg.updateUrl}.js`, { updates });
        const gone = plan.remove.filter((r) => r.qty === 0).map((r) => r.variant);
        store.set('added', store.get('added', []).filter((v) => !gone.includes(v)));
        changed = true;
      }
      if (plan.add.length) {
        await req(`${cfg.addUrl}.js`, { items: plan.add.map((id) => ({ id, quantity: 1, properties: { [PROP]: '1' } })) });
        store.set('added', [...new Set([...store.get('added', []), ...plan.add])]);
        changed = true;
      }
      if (changed) cart = await getCart();
      log(reason, { aktiv: on, schwelle: plan.base / 100, frei: plan.unlocked, gekauft: plan.bought, neu: plan.add, raus: plan.remove });

      // 3. Sicherheitsnetz: Geschenk kostet trotz aktiver Aktion etwas → Geschenk-Rabatt greift nicht → wieder raus
      if (on && !test && cart.items.some((l) => isAuto(l) && l.final_line_price > 0)) {
        await new Promise((r) => setTimeout(r, 1500));
        cart = await getCart();
        const paid = cart.items.filter((l) => isAuto(l) && l.final_line_price > 0);
        if (paid.length) {
          const updates = {};
          paid.forEach((l) => (updates[l.key] = 0));
          await req(`${cfg.updateUrl}.js`, { updates });
          store.set('paused', true);
          store.set('added', []);
          console.warn('[herbst-promo] Geschenk-Rabatt greift nicht, Geschenke wieder entfernt:', paid.map((l) => l.title));
          cart = await getCart();
          changed = true;
        }
      }

      if (changed) await refreshUI(cart);
    } catch (err) {
      console.error('[herbst-promo]', err);
    } finally {
      busy = false;
      if (again) {
        again = false;
        schedule('nachgeholt');
      }
    }
  }

  // ---------- Oberfläche aktualisieren (ohne cartUpdate-Event, das den Drawer hier falsch neu rendert) ----------
  async function refreshUI(cart) {
    try {
      const res = await nativeFetch(`${cfg.rootUrl.replace(/\/$/, '')}/?sections=cart-drawer,cart-icon-bubble`);
      if (res.ok) {
        const s = await res.json();
        const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
        const inner = document.getElementById('CartDrawer');
        const fresh = s['cart-drawer'] && parse(s['cart-drawer']).querySelector('#CartDrawer');
        const drawer = document.querySelector('cart-drawer');
        if (inner && fresh) {
          inner.innerHTML = fresh.innerHTML;
          if (drawer) {
            drawer.classList.toggle('is-empty', !cart.item_count);
            drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
          }
        }
        const bubble = document.getElementById('cart-icon-bubble');
        const freshBubble = s['cart-icon-bubble'] && parse(s['cart-icon-bubble']).querySelector('.shopify-section');
        if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      }
    } catch (e) {
      console.error('[herbst-promo]', e);
    }
    // Warenkorbseite (nur das Haupt-Element, nicht der Drawer)
    const mainCart = document.querySelector('cart-items');
    if (mainCart && typeof mainCart.onCartUpdate === 'function') mainCart.onCartUpdate();
    if (typeof window.fetchCartItems === 'function') window.fetchCartItems();
    window.dispatchEvent(new CustomEvent('herbst-promo:updated', { detail: { cart } }));
  }

  // ---------- Auslöser: jede Warenkorb-Änderung, egal von wem ----------
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = nativeFetch(input, init);
    if (CART_RE.test(url)) p.then(() => schedule('fetch'), () => {});
    return p;
  };
  const xOpen = XMLHttpRequest.prototype.open;
  const xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u, ...rest) {
    this.__herbstUrl = String(u);
    return xOpen.call(this, m, u, ...rest);
  };
  XMLHttpRequest.prototype.send = function (...a) {
    if (CART_RE.test(this.__herbstUrl || '')) this.addEventListener('loadend', () => schedule('xhr'));
    return xSend.apply(this, a);
  };

  window.HerbstPromo = { reconcile, active, cfg, gifts, test };
  log('bereit', { aktiv: active(), start: cfg.start, ende: cfg.end || '–', code: cfg.code, geschenke: gifts });
  schedule('seitenaufruf');
})();
